import PaymentPageComponent from "./paymentPage/paymentPageComponent";


export default function PaymentPage() {
    return (<div>
        <PaymentPageComponent/>
    </div>);
}

